import { MenuItem, Select } from '@mui/material';
import { ContractType } from '../../../../../../shared/types/offers';

interface ContractTypeSelectorProps {
  value?: ContractType;
  onContractTypeChange: (value: ContractType) => void;
}

const ContractTypeSelector: React.FC<ContractTypeSelectorProps> = ({
  value,
  onContractTypeChange,
}) => {
  return (
    <Select
      size="small"
      value={value}
      onChange={(event) =>
        onContractTypeChange(event.target.value as ContractType)
      }
      sx={{
        width: '100%',
        my: 1,
      }}
    >
      <MenuItem value={ContractType.Normal}>Normaali</MenuItem>
      <MenuItem value={ContractType.SinglePayment}>
        Single payment
      </MenuItem>
      <MenuItem value={ContractType.RamifleetNew}>
        Ramifleet - Uusi kalusto
      </MenuItem>
      <MenuItem value={ContractType.RamifleetOld}>
        Ramifleet - Käytetty kalusto
      </MenuItem>
    </Select>
  );
};

export default ContractTypeSelector;
